import { createContext, useContext, useEffect, useMemo, useState } from "react";

/* ============================================================================
   REDISENO-SMARTMEDIC FASE 2 (TopBar) -- subtítulo de la pantalla.

   El título sale de la ruta (`utils/tituloPagina.js`), pero el documento pide
   además "el conteo del filtro activo" -- eso sólo lo sabe la pantalla. Este
   contexto es el canal mínimo para que una pantalla publique esa línea sin que
   la barra superior tenga que conocerla.

   Es OPCIONAL: una pantalla que no lo usa simplemente no tiene subtítulo, y el
   hook limpia lo que publicó al desmontarse para que no quede colgando en la
   siguiente.
   ========================================================================== */

const PageHeaderContext = createContext({ subtitulo: "", setSubtitulo: () => {} });

export function PageHeaderProvider({ children }) {
    const [subtitulo, setSubtitulo] = useState("");
    const valor = useMemo(() => ({ subtitulo, setSubtitulo }), [subtitulo]);
    return <PageHeaderContext.Provider value={valor}>{children}</PageHeaderContext.Provider>;
}

export function usePageHeader() {
    return useContext(PageHeaderContext);
}

/** Publica el subtítulo de la pantalla actual; se limpia al salir de ella. */
export function usePageSubtitulo(texto) {
    const { setSubtitulo } = usePageHeader();
    useEffect(() => {
        setSubtitulo(texto || "");
        return () => setSubtitulo("");
    }, [texto, setSubtitulo]);
}

export default PageHeaderContext;
